import React from "react";
import Sidebar from "./Sidebar";
import TopNav from "./TopNav";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="app">
      <Sidebar />
      <main className="main-content">
        <TopNav />
        <div className="main-content__container">{children}</div>
        <Footer />
      </main>
    </div>
  );
};

export default Layout;
